import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Steampunk keyboard",
  "description": "",
  "published": "2007-02-28T00:00:00.000Z",
  "redirect_from": ["/blog/steampunk-keyboard/swizec/277"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I've always known I loved this style, but now I actually know that it's called steampunk. You have to admit it's a bloody awesome style. Anyhow,`}<a parentName="p" {...{
        "href": "http://steampunkworkshop.com/keyboard.shtml"
      }}>{` here`}</a>{`'s a cool steampunk keyboard and I'd really like to get my hands on one.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      